import { render, staticRenderFns } from "./PaidConsultation.vue?vue&type=template&id=1ac750be&lang=pug"
import script from "./PaidConsultation.vue?vue&type=script&lang=ts"
export * from "./PaidConsultation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports